import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sf_lead_id: "",
};

export const salesforceLeadIdSlice = createSlice({
  name: "salesForceLeadId",
  initialState,
  reducers: {
    setSfLeadId: (state, action) => {
      if (state.sf_lead_id === "") {
        state.sf_lead_id = action.payload;
      }
    },
  },
});

export const { setSfLeadId } = salesforceLeadIdSlice.actions;

export default salesforceLeadIdSlice.reducer;
